import { Component, Inject, Input, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";

@Component({
	selector: "app-confirm-reason-modal",
	templateUrl: "./confirm-reason-modal.component.html",
	styleUrls: ["./confirm-reason-modal.component.scss"],
})
export class ConfirmReasonModalComponent implements OnInit {
	@Input() message = "";
	@Input() showToggle = false;
	@Input() toggleLabels = [];
	@Input() isToggleInput = false;
	@Input() toggleText = "";

	reason = new FormControl("", [Validators.required]);
	toggleInput = new FormControl();
  	toggleState = false;

	constructor(
		private dialogRef: MatDialogRef<ConfirmReasonModalComponent>,
		@Inject(MAT_DIALOG_DATA) data: {message: string, showToggle?: boolean, toggleLabels?: string[], isToggleInput?: boolean, toggleText?: string},
		private params: ActivatedRoute
	) {
		if(data != null){
			this.message = data.message;
			this.showToggle = data.showToggle ?? false;
			this.toggleLabels = data.toggleLabels ?? [];
			this.isToggleInput = data.isToggleInput ?? false;
			this.toggleText = data.toggleText ?? "";
		}
	}

	ngOnInit() {}

	async close(confirmed: boolean) {
		if (!confirmed) {
			this.dialogRef.close({ confirmed: confirmed })
		}
		if (!this.reason.valid) {
			this.reason.markAsTouched();
			return;
		}
		if(!this.toggleInput.valid){
			this.reason.markAsTouched();
			return;
		}
		this.dialogRef.close({
			confirmed: confirmed,
			reason: this.reason.value,
      		toggleInputValue: this.toggleInput.value,
		});
	}

	toggleChange(){
		this.toggleState = !this.toggleState;
		if (this.toggleState) {
		  this.toggleInput = new FormControl("", [Validators.required]);
		} else {
		  this.toggleInput = new FormControl();
		}
	}
}
